<template>
	<div class="documents">
		<ul class="documents__list">
      <li v-for="(item, key) in documents" :key="key" class="documents__item">
        <a :href="item.url" target="_blank">
          <app-icon name="pdf" />
          <span>{{ item.name }}</span>
        </a>
      </li>
    </ul>
	</div>
</template>

<script>
  import { mapState } from 'vuex'

	import Icon from '@/components/icon'

	export default {
		components: {
			appIcon: Icon
		},
    computed: {
      ...mapState('tours', ['documents'])
    }
	}
</script>

<style lang="scss">
  .documents {
    &__list {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 20px;
    }

    &__item {
      position: relative;
      margin: 12px;
      border: 2px solid var(--color-documents-item-border);

      &:hover {
        &:before {
          top: -6px;
        }
      }

      &:before {
        content: '';
        position: absolute;
        top: -2px;
        left: 0;
        z-index: 1;
        width: 100%;
        height: 2px;
        background-color: var(--color-documents-item-border);
        transition: top .2s ease-out;
      }

      a {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        padding: 15px 25px;
      }

      span {
        position: relative;
        top: 1px;
        margin-left: 10px;
				font-size: 15px;
				color: var(--color-documents-text);
				line-height: 1;
        text-transform: uppercase;
      }
    }

    .icon-pdf {
      width: 32px;

      path {
        transition: fill .3s ease-out;

        &:first-child {
          fill: var(--color-documents-icon-1-part);
        }

        &:last-child {
          fill: var(--color-documents-icon-2-part);
        }
      }
    }
  }
</style>
